import { IsNotEmpty } from "class-validator";
import { AdapterTimeCardDto } from "../adapter-timecard.dto";

export class OracleCloudAdapterTimeCardDto extends AdapterTimeCardDto {
  @IsNotEmpty()
  LaborInstanceName: string;
}
